// ── Settings/thresholds hooks (FR-SET) ──────────────────────────────────────
// The list read is view.settings; the per-threshold upsert is manage.settings
// (SA/Admin) + a UUID Idempotency-Key. On success the upsert response row is
// merged into the thresholds cache (class-12 write-truth) — never list invalidate.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCoachingReadinessServices } from "../services/coaching-service-provider";
import type { CoachingThresholdUpsertRequest } from "../services/coaching-readiness-dtos";
import { cacheThresholdUpsertReadback } from "./coaching-write-truth-caches";
import { createIdempotencyKey } from "./useCoachingQueries";

export function useThresholdUpsertMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CoachingThresholdUpsertRequest) =>
      getCoachingReadinessServices().settings.upsertThreshold(body, createIdempotencyKey(`settings-threshold:${body.key}`)),
    onSuccess: (data) => {
      if (data?.threshold) cacheThresholdUpsertReadback(queryClient, data.threshold);
    }
  });
}
